/**
 * 环境配置，要与其他东西分离，防止循环引用
 */
define([],function(){
    var ENV = {};
    
    // 根据IP判断是否显示国际站
    ENV.ipIsInternational = function(){
        var cookieStr = document.cookie;
        var cookieArray = cookieStr.split(";");
        for (var i = 0; i < cookieArray.length; i++) {
            var arr= cookieArray[i].toString().split("=");
            if (arr[0].trim() === "Site") {
                // mainland国内IP intl国际IP
                return decodeURIComponent(arr[1]) === "intl";
            }
        }
        return false;
    };

    ENV.IS_PUBLISH_ENV = true;
    
    ENV.SERVER_CONFIG = {
        "PROTOCOL": "https",
        "SERVER_IP": "",
        "SERVER_PORT": ""
    }
	
    ENV.isPublishEnv = function() {
    	// 是否是发布环境
        if (ENV.IS_PUBLISH_ENV !== undefined && ENV.IS_PUBLISH_ENV !== "") {
            return ENV.IS_PUBLISH_ENV;
        }
        return true;
    }
    ENV.getUrlPrefix = function() {
    	var protocol = ENV.SERVER_CONFIG.PROTOCOL;
        var ip = ENV.SERVER_CONFIG.SERVER_IP;
        var port = ENV.SERVER_CONFIG.SERVER_PORT;
        var url_pre = "";
        if (protocol !== "" && ip !=="" && port !== "") {
            url_pre = protocol + "://" + ip + ":" + port;
        }
        return url_pre;
    };

    return ENV;
});


// WEBPACK FOOTER //
// ./public/hws/js/iamEnv.js